import React from 'react';
import { Avatar as AntRow, AvatarProps } from '@vertem-core/vertice-ds';

const Avatar: React.FC<AvatarProps> = (props) => <AntRow {...props} />;

export default Avatar;
